import ApiService from '../api.services';

const NotificationTemplateService = {
    list: async function (customer) {
        try {
            const response = await ApiService.get(`/api/notification.template?customer=${customer || ''}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    history: async function (id) {
        try {
            const response = await ApiService.get(`/api/notification.template/history/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    types: async function () {
        try {
            const response = await ApiService.get(`/api/notification.template/type/list`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const response = await ApiService.get(`/api/notification.template/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    add: async function (data) {
        try {
            const response = await ApiService.post('/api/notification.template', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    update: async function (id, data) {
        try {
            const response = await ApiService.put(`/api/notification.template/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/notification.template/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    configuration: async function (type, customer) {
        try {
            const response = await ApiService.get(`/api/notification.template/configuration/${type.toLowerCase()}?customer=${customer || ''}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};

export default NotificationTemplateService;

export { NotificationTemplateService };

